import * as React from 'react';
import useStickyPosition from '../../../../hooks/use-sticky-postion';
import InPageNavigation from 'ted-ui/build/InPageNavigation';
import { OrderDetailsSections } from '@applications/order-tracker/config/order-tracker-new-common/constants';
import { generateElementId } from '@applications/order-tracker/utils';
import { Application } from '@applications/order-tracker';
import { Components } from '@telstra-connect/order-tracker/activity-tracking';
import OrderSummary from '../../../order-summary';
import ProductsOrdered from '../../../products-ordered';
import HelpAndSupportOrderDetails from '../../../help-and-support';
import OrderDetailsHeader from '../../../order-details-header';
import '../../../../style.less';

const iconDevelopmentURL = require('../../../../../../../../images/able-sprites.svg');

const TConnectOrderDetails = ({ orderNumber }: { orderNumber: string }) => {
  const { stickyPosition } = useStickyPosition();

  const trackClick = (label: string): void => {
    Application.tracker.trackLink(label, Components.orderDetailsPage);
  };

  const orderDetailsNavLinks: Array<{
    label: string;
    id: string;
    events: Record<string, unknown>;
  }> = Object.entries(OrderDetailsSections).map(([key, value]) => ({
    label: value,
    id: generateElementId(value),
    events: {
      onClick: () => trackClick(value),
    },
  }));

  return (
    <React.Fragment>
      <OrderDetailsHeader orderNumber={orderNumber} />
      <InPageNavigation
        className="order-details-navigation"
        links={orderDetailsNavLinks}
        stickyPosition={stickyPosition}
        developmentUrl={iconDevelopmentURL}
        children={
          <React.Fragment>
            <OrderSummary />
            <ProductsOrdered />
            <HelpAndSupportOrderDetails />
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
};

export default TConnectOrderDetails;
